// src/analytics/AnalyticsProvider.jsx
// React Provider component for Google Analytics 4 initialization

import React, { useEffect } from 'react';
import { initAnalytics } from './analyticsClient';

/**
 * AnalyticsProvider component
 * Initializes Google Analytics 4 from environment variable
 * Should be mounted at the app root level
 */
const AnalyticsProvider = ({ children }) => {
  useEffect(() => {
    // Read Measurement ID from environment variable
    // React Scripts uses REACT_APP_ prefix for environment variables
    const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

    if (measurementId && measurementId.trim() !== '') {
      initAnalytics(measurementId);
    } else {
      if (process.env.REACT_APP_ENVIRONMENT === 'development') {
        console.warn(
          '[Analytics] REACT_APP_GA4_MEASUREMENT_ID not configured. ' +
          'Analytics will be disabled. Set this environment variable to enable GA4 tracking.'
        );
      }
    }
  }, []);

  return <>{children}</>;
};

export default AnalyticsProvider;

